import MvSpinner from "./MvSpinner";
export default MvSpinner;
